import type { PhoneCallDto } from '@mark43/cad-api';

export function isCallForStation(
    phoneCall: PhoneCallDto,
    currentStationId: number | undefined
): boolean {
    return currentStationId != null && phoneCall.stationId === currentStationId;
}
